var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakaoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6C11.716 6 5 11.373 5 18C5 22.303 7.833 26.077 12.094 28.194L10.39 34.08C10.237 34.604 10.835 35.021 11.289 34.714L18.234 30.02C18.813 30.073 19.402 30.1 20 30.1C28.284 30.1 35 24.728 35 18C35 11.373 28.284 6 20 6Z",
    fill: "#FEE500"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 18,
    r: 1.35,
    fill: "#241F13"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 1.35,
    fill: "#241F13"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 18,
    r: 1.35,
    fill: "#241F13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoColor);
export default __webpack_public_path__ + "static/media/kakaoColor.8ddc49ca00f86e98d596a55c91e697c0.svg";
export { ForwardRef as ReactComponent };